<script setup lang="ts">
import { type PropType, ref } from 'vue'
import { useSchedulesTree } from './../model/model.ts'
import type { ScheduleTreeItemType } from './../model/types.ts'
import { VIcons } from '@/shared/ui'
import ScheduleTreeIcon from './ScheduleTreeIcon.vue'
import { useRoute, useRouter } from 'vue-router'

const props = defineProps({
  item: {
    type: Object as PropType<ScheduleTreeItemType>,
    required: true,
  },
})

const open = ref(false)
const tree = useSchedulesTree()
const router = useRouter()
const route = useRoute()
const { refetch, isLoading } = tree.loadChild(props.item)

/**
 * Функция обработки клика для получения потомков
 */
const clickOpenHandler = async () => {
  await refetch()

  open.value = !open.value
}

/**
 * Вызов контекстного меню
 * @param event
 */
const contextHandler = (event: MouseEvent) => {
  if (!props.item?.type || props.item.type == 3) return

  tree.contextObject = props.item
  tree.contextPosition = {
    x: event.clientX,
    y: event.clientY,
  }
}

/**
 * Функция обработки клика по элементу списка
 */
const clickHandler = () => {
  if (!props.item?.type || props.item.type == 3) return

  const tab = route.params.sked_tab || 'programs'

  router.push(`/schedules/${props.item.id}/${tab}`)
}
</script>

<template>
  <div class="v-tree__item">
    <div
      v-if="item.children"
      class="v-tree__folder"
      :class="{ 'v-tree__folder_open': open }"
      @click="clickOpenHandler"
    >
      <VProgressCircular v-if="isLoading" color="white" indeterminate :size="12" :width="2" />

      <VIcons v-else type="arrow_right" />
    </div>

    <div
      ref="treeItem"
      class="v-tree__name"
      @click.right.prevent="contextHandler"
      @click="clickHandler"
      :class="{
        'v-tree__name_selected': item.id == Number(route.params.schedule_id),
      }"
    >
      <ScheduleTreeIcon :type="item.type" />
      {{ item.name }}
    </div>

    <div v-if="item.children_list && open" class="v-tree__children">
      <SchedulesTreeItem v-for="object in item.children_list" :item="object" :key="object.id" />
    </div>
  </div>
</template>
